'use client'

import { SessionProvider } from 'next-auth/react'
import { usePathname } from 'next/navigation'
import { PlayerProvider } from '@/lib/player-context'
import { PartyProvider } from '@/lib/party-context'
import { TrackMenuProvider } from './TrackMenu'
import ToastHost from './ToastHost'
import TvLogin from './TvLogin'

export default function Providers({ children }: { children: React.ReactNode }) {
  // Coque TV verticale (/tvp) : elle n'affiche qu'un cadre contenant l'appli —
  // AUCUN fournisseur ici (sinon 2e lecteur audio, 2e connexion soirée, 2e
  // session qui tournent en double sur la box → appli très lente).
  const pathname = usePathname()
  if (pathname === '/tvp') return <>{children}</>
  return (
    <SessionProvider>
      <PlayerProvider>
        <PartyProvider>
          <TrackMenuProvider>
            {children}
          </TrackMenuProvider>
        </PartyProvider>
        <ToastHost />
        {/* Connexion Google assistée par téléphone — global (dispo sur /login,
            /app, la TV…). Ouvert par l'événement 'blc-tv-login-open'. */}
        <TvLogin />
      </PlayerProvider>
    </SessionProvider>
  )
}
